import { render, staticRenderFns } from "./ZwyHotelDirectOrder.vue?vue&type=template&id=60c3448d&scoped=true"
import script from "./ZwyHotelDirectOrder.vue?vue&type=script&lang=js"
export * from "./ZwyHotelDirectOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c3448d",
  null
  
)

export default component.exports